module.exports = __webpack_public_path__ + "img/ZV1FW.adf5aa74.jpg";